import { API_URL } from "../../utils/url-constants";
import axiosMain from "./intercepters";
import axios from "axios";

// Auth
export async function signIn(payload) {
  return await axiosMain.post(`${API_URL.auth.login}`, payload);
}
export async function registerClinic(payload) {
  return await axiosMain.post(`${API_URL.auth.registerClinic}`, payload);
}
export async function VerifEmail(id,token) {
  return await axiosMain.post(`${API_URL.auth.verifyEmail}?id=${id}&token=${token}`);
}
export async function deleteUser(email,type) {
  return await axiosMain.post(`${API_URL.auth.deleteUser}?email=${email}&type=${type}`);
}
export async function sendEmail(email,type) {
  return await axiosMain.post(`${API_URL.auth.sendEmail}?email=${email}&type=${type}`);
}
export async function VerifDoctorEmail(id,token) {
  return await axiosMain.post(`${API_URL.auth.verifyDoctorEmail}?id=${id}&token=${token}`);
}

export async function ResendOtp(email) {
  return await axiosMain.post(
    `${API_URL.auth.resendOTP}?email=${email}`
  );
}
export async function forgotPassword(payload) {
  return await axiosMain?.post(`${API_URL?.auth?.forgotPassword}`, payload);
}
export async function resetPassword(payload) {
  return await axiosMain?.post(`${API_URL?.auth?.ResetPassword}`, payload);
}

export async function getAllUpcomingAppointmentListByDate(clinicId, date, languageType) {
  return await axiosMain?.get(`${API_URL?.dashboard?.getUpcomingAppointmentListByDate}?clinicId=${clinicId}&date=${date}&languageType=${languageType}`);
}

// Generic file upload
export async function uploadFile(payload) {
  return await axios?.post(`${API_URL?.baseURL}${API_URL?.fileUpload?.file}`, payload);
}

// Aliases (optional for semantic usage)
export const postFileUpload = uploadFile;
export const postMultiFileUpload = uploadFile;
// clinic profile
export async function getCLinicById(clinicId, languageType, staffId = 0) {
  return await axiosMain?.get(
    `${API_URL?.clinicProfile?.getCLinicById}?clinicId=${clinicId}&languageType=${languageType}&clinicStaffId=${staffId}`
  );
}
// clinic rating 
export async function clinicRating(payload) {
  return await axiosMain?.post(
    `${API_URL?.clinicRating?.ratingClinic}`, payload
  );
}
// add clinic banke details
export async function addbank(payload) {
  return await axiosMain?.post(`${API_URL?.bank?.AddBank}`, payload);
}
export async function getAllBankDetailes(payload) { //not found
  return await axiosMain?.post(`${API_URL?.bank?.BankDetailes}`, payload);
}


// uploadClinicContract
export async function uploadCLinicContract(clinicId, contract) {
  return await axiosMain?.get(
    `${API_URL?.uploadCLinicContract?.uploadContract}?clinicId=${clinicId}&contract=${contract}&type=CLINIC`
  );
}

// doctor add api
export async function getDoctorEmailId(payload) {
  return await axiosMain?.get(
    `${API_URL?.doctor?.getDoctorEmailId}?email=${payload}`
  );
}
export async function addClinicDoctor(docId, clinicId) { //not found
  return await axiosMain?.post(
    `${API_URL?.doctor?.addClinicDoctorId}?clinicId=${clinicId}&doctorId=${docId}`
  );
}

export async function getQuestionAnswer(doctorId, patientId, languageType) { //not found
  return await axiosMain?.get(
    `${API_URL?.doctor?.getPreAppointmentQuestions}?doctorId=${doctorId}&patientId=${patientId}&languageType=${languageType}`
  );
}
export async function doctoraddByClinic(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctor?.doctoraddByClinicRegistration}`,
    payload
  );
}
export async function getSpecializationList(lang) {
  return await axiosMain?.get(
    `${API_URL?.doctor?.getSpecialization}?lang=${lang}`
  );
}
export async function getAllDoctorList(clinicId, searchText) {
  return await axiosMain?.get(
    `${API_URL?.doctor?.getAllList}?clinicId=${clinicId}&searchTest=${searchText}`
  );
}
export async function doctorBlockByClinic(clinicId, doctorId, status) {
  return await axiosMain?.get(
    `${API_URL?.doctor?.doctorBlockByClinic}?id=${clinicId}&doctorId=${doctorId}&status=${status}&type=CLINIC`
  );
}
export async function doctorAllDoctorProfile(lang) {
  return await axiosMain?.get(`${API_URL?.doctor?.doctorProfile}?type=${lang}`);
}

export async function addQuestionNew(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctor?.add_pre_appointment_questionNew}`,
    payload
  );
}

export async function getAllDoctorDetailes(doctorId, languageType) { //not found
  return await axiosMain?.get(
    `${API_URL?.doctor?.DOCTORDETAILES}?doctorId=${doctorId}&doctorStaffId=0&languageType=${languageType}`
  );
}

export async function getPreAppointmentQuestionsById(id, languageType) {
  return await axiosMain?.get(
    `${API_URL?.doctor?.getAllPreAppointmentQuestionsById}?id=${id}&languageType=${languageType}`
  );
}
export async function getExpertiesById(id, languageType) {
  return await axiosMain?.get(
    `${API_URL?.doctor?.getExpertiesById}?doctorId=${id}&languageType=${languageType}`
  );
}
// Job Management

export async function AddJobRequirement(payload) {
  return await axiosMain.post(
    `${API_URL.Jobmatching_Management.addjobrequirement}`,
    payload
  );
}

export async function getAllJobPost(payload) {
  return await axiosMain?.post(
    `${API_URL?.Jobmatching_Management?.getalljobpost}`,
    payload
  );
}

export async function OpencloseClinicJobpost(id, status) {
  return await axiosMain?.get(
    `${API_URL?.Jobmatching_Management?.Openclosejobpost}?id=${id}&status=${status}`
  );
}

export async function getAllMatching(payload) {
  return await axiosMain?.post(
    `${API_URL?.Jobmatching_Management?.getAllmyMatching}`,
    payload
  );
}
export async function getAllMatchingDashbaordfilter(payload) {
  return await axiosMain?.post(
    `${API_URL?.Jobmatching_Management?.getAllDashbaordfiltermatching}`,
    payload
  );
}

export async function getSpecializationByClinic(clinci, languageType) {
  return await axiosMain?.get(
    `${API_URL?.Jobmatching_Management?.getSpecializationbyclinicIdDas}?clinicId=${clinci}&languageType=${languageType}`
  );
}
export async function jobMatchingDashboard(payload) {
  return await axiosMain?.post(
    `${API_URL?.Jobmatching_Management?.matchingBySpecializationDashboard}`,
    payload
  );
}

//country
export async function getCountrybytype(lang) {
  return await axiosMain?.get(
    `${API_URL?.country?.getallCountry}?type=${lang}`
  );
}
export async function getAllCitiesByCountry(countryId, type) {
  return await axiosMain?.get(
    `${API_URL?.country?.getCitiesByCountryId}?countryId=${countryId}&type=${type}`
  );
}
export async function addDoctorFeesByClinic(docId, clinicId, fees, doctorPercentage, clinicPercentage) {
  return await axiosMain?.post(
    `${API_URL?.doctor?.addDoctorFees}?clinicId=${clinicId}&doctorId=${docId}&fees=${fees}&doctorPercentage=${doctorPercentage}&clinicPercentage=${clinicPercentage}`
  );
}

// availability management
export async function doctorListforAvailability(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.getAllClinicDoctorList}`,
    payload
  );
}

// export async function getExpertiesById(doctorId,languageType) {
//   return await axiosMain?.get(
//     `${API_URL?.doctorAvailability?.getDoctorExpertiesById}?doctorId=${doctorId}&languageType=${languageType}`
//   );
// }
export async function blockDoctorAvailabilityByTimeSlot(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.blockBySlot}`,
    payload
  );
}

export async function blockDoctorAvailabilityByDates(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.blockDoctorAvailabilityByDate}`,
    payload
  );
}

export async function blockDoctorAvailabilityByRecurring(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.blockDoctorAvailabilityByRecurring}`,
    payload
  );
}
export async function addDoctorAvailability(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.addAvailability}`,
    payload
  );
}

export async function updateDoctorAvailability(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.updateAvailability}`,
    payload
  );
}
export async function availabiltySlotListDoctorWise(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.availabiltySlotListDoctorWise}`,
    payload
  );
}
export async function blockAvailabiltyDateWise(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.blockAvailabilityByDate}`,
    payload
  );
}
export async function blockAvailabilitySlotWise(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.blockAvailabilityBySlot}`,
    payload
  );
}

export async function blockAvailabilty(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.blockAvailability}`,
    payload
  );
}
export async function getallClinicDoctorAvaialbilty(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.getAllclinicdoctorblock}`,
    payload
  );
}
export async function restoreBlockAvailabilityAll(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.restoreBlockAvailability}?id=${payload}`
  );
}
export async function deleteAvailability(payload) {
  return await axiosMain?.post(
    `${API_URL?.doctorAvailability?.deleteAvailability}`,
    payload
  );
}
export async function findAllDoctorAvailabilityByClinicId(clinicId, languageType) {
  return await axiosMain?.get(
    `${API_URL?.doctorAvailability?.findDoctorAvailability}?clinicId=${clinicId}&languageType=${languageType}`
  );
}

//dashboard chart
export async function getDoctorsCountByClinic(clinicId) {
  return await axiosMain?.get(
    `${API_URL?.Chart?.doctorsCountByClinic}?clinicId=${clinicId}`
  );
}

// static pages
// term and condition && Privacy policy

export async function getAllPrivacyPolicyAndTermandCondition(type) {
  return await axiosMain?.get(
    `${API_URL?.staticApi?.getAllPrivacyPolicyAndTermandCondition}?type=${type}`
  );
}
// contatcus
export async function getallContactUs() {
  return await axiosMain?.get(`${API_URL?.staticApi?.getAllContactus}`);
}

// My Appointment List
export async function appointmentList(payload) {
  return await axiosMain?.post(
    `${API_URL?.myAppointmentList?.appointmentList}`,
    payload
  );
}


export async function patientChangeStatusApi(bookingId ,status ) {
  return await axiosMain?.get(
    `${API_URL?.myAppointmentList?.patientchangestatus}?bookingId=${bookingId }&status=${status }`
  );
}
// My Patient List
export async function myPatientList(payload) {
  return await axiosMain?.post(
    `${API_URL?.myPatientList?.patientList}`,
    payload
  );
}

// role -managment
export async function getAllRoles(payload) {
  return await axiosMain?.post(`${API_URL?.role?.getAllRole}`, payload);
}
export async function PostAddRole(payload) {
  return await axiosMain?.post(`${API_URL?.role?.AddRole}`, payload);
}
export async function PostUpdateRole(payload) {
  return await axiosMain?.post(`${API_URL?.role?.AddRole}`, payload);
}
export async function getRoleById(roleId, languageType) {
  return await axiosMain?.get(
    `${API_URL?.role?.getRoleById}?roleId=${roleId}&languageType=${languageType}`
  );
}
export async function RoleStatus(id, status) {
  return await axiosMain?.get(
    `${API_URL?.role?.RoleStatus}?id=${id}&status=${status}`
  );
}

export async function getAllModule(languageType, type = "clinicModule") {
  return await axiosMain?.get(`${API_URL?.module?.getAllModule}?type=${type}&languageType=${languageType}`);
}
// staff
// Staff
export async function postAllStaff(payload) {
  return await axiosMain?.post(`${API_URL?.staff?.getAllStaff}`, payload);
}
export async function PostAddStaff(payload) {
  return await axiosMain?.post(`${API_URL?.staff?.addStaff}`, payload);
}
export async function PostUpdateStaff(payload) {
  return await axiosMain?.post(`${API_URL?.staff?.addStaff}`, payload);
}
export async function getStaffById(id, languageType) {
  return await axiosMain?.get(`${API_URL?.staff?.getStaffById}?id=${id}&languageType=${languageType}`);
}
export async function StaffStatus(id, status) {
  return await axiosMain?.get(
    `${API_URL?.staff?.staffStatus}?id=${id}&status=${status}`
  );
}

// My Patient List
export async function myPaymentList(payload) {
  return await axiosMain?.post(
    `${API_URL?.payment?.accountSummery}`,
    payload
  );
}

// notification 
export async function allNotification(payload) {
  return await axiosMain?.post(
    `${API_URL?.notification?.getNotification}`,
    payload
  );
}

// translationa api
export async function translateLanguage(type, payload) {
  return await axiosMain?.post(
    `${API_URL?.deepL?.translateLanguage}?targetLang=${type}`,
    payload
  );
}

// payment doctor invoice
export async function getDoctorInvoiceList(payload) {
  return await axiosMain?.post(
    `${API_URL?.payment?.DoctorInvoiceList}`,
    payload
  );
}
export async function getDoctorInvoiceDownload(payload) {
  return await axiosMain?.post(
    `${API_URL?.payment?.DoctorInvoiceDownload}`,
    payload
  );
}

// Subscription

export async function getAllSubscriptionApi(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.getAllSubscription}`,
    payload
  );
}

export async function createPayPalOrder(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.createPaypalOrder}?`,payload
  );
}
export async function createPayPalOrderForServer(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.createPaypalOrderServer}`,payload
    
  );
  
}

export async function createStripeOrderForServer(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.createStripeOrderServer}`,payload
  );
}
export async function subscriptionProcessPayment(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.processPayment}`, payload
  );
}
export async function confirmStripePayment(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.processConfirm}`, payload
  );
}

export async function addPayPalWalletNew(payload) {
  return await axiosMain?.post(
    `${API_URL?.subscription?.addWalletNew}`, payload
  );
}